<template>
  <div>
    <loader :loader="sending" />

    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <validation-observer ref="observer" v-slot="{ invalid }">
          <v-card-text>
            <patient-information
              v-if="model && model.idPatient"
              :model="model"
              class="mb-4 mt-4"
            />

            <v-divider class="mb-12 mt-8"></v-divider>
            <v-row align="center" justify="center" dense>
              <v-col cols="12" md="4" xl="4" sm="12">
                <validation-provider
                  v-slot="{ errors }"
                  name="adjuntar archivos"
                  rules="maxSizeFile"
                >
                  <v-file-input
                    v-model="files"
                    placeholder="Seleccione los archivos"
                    label="Adjuntar archivos"
                    multiple
                    show-size
                    counter
                    prepend-icon="mdi-paperclip"
                    accept="image/png, image/jpeg, image/bmp, application/pdf"
                    :error-messages="errors"
                  ></v-file-input>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row class="d-flex flex-wrap" align="center" justify="center">
              <v-col
                md="4"
                sm="6"
                cols="4"
                v-for="(file, index) in files"
                :key="index"
              >
                <v-card
                  height="250%"
                  style="font-size: 1vw"
                  class="d-flex align-center justify-center flex-wrap"
                >
                  <v-card-text
                    class="text-center d-flex flex-column align-center justify-center"
                  >
                    <h1 class="my-2" style="font-size: 120%">
                      {{ file.name }}
                    </h1>
                    <v-icon
                      size="50"
                      :color="
                        file.type === 'application/pdf'
                          ? 'error'
                          : 'grey' || file.type === 'image/jpeg'
                          ? 'secondary'
                          : 'grey'
                      "
                      >{{
                        file.type === "application/pdf"
                          ? "mdi-file-pdf-box"
                          : "mdi-file" || file.type === "image/jpeg"
                          ? "mdi-image"
                          : "mdi-file"
                      }}</v-icon
                    >
                  </v-card-text>
                  <v-card-actions class="d-flex justify-center">
                    <v-btn
                      plain
                      color="error"
                      style="font-size: 0.8vw"
                      @click="deleteFile(file.name)"
                      v-if="$utilFront.withPermission($prm.DELETE_ADDENDUM)"
                    >
                      Eliminar
                      <v-icon style="font-size: 1vw" right>mdi-delete</v-icon>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
            </v-row>

            <v-row class="d-flex flex-nowrap" align="baseline">
              <v-col
                cols="3"
                class="text-center"
                align="center"
                v-for="(scannedImage, index) in scannedImages"
                :key="index"
              >
                <img :src="scannedImage.file64" height="220" />
                <br />
                <v-btn
                  class="mx-2"
                  @click="scannedImages.splice(index, 1)"
                  fab
                  mdi-icon
                  x-small
                  light
                >
                  <v-icon x-large color="red">mdi-delete-circle</v-icon>
                </v-btn>
                <validation-provider
                  v-slot="{ errors }"
                  :name="index + 1 + '. Imagen'"
                  rules="required"
                >
                  <v-text-field
                    prepend-icon="mdi-file"
                    v-model.trim="scannedImage.fileName"
                    :error-messages="errors"
                    label="Nombre de archivo"
                    required
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row class="d-flex flex-nowrap mb-12" align="baseline">
              <v-col
                align="center"
                cols="3"
                class="text-center"
                v-for="(pdf, index) in scannedPDF"
                :key="index"
              >
                <iframe :src="pdf.file64" height="220" />
                <br />
                <v-btn
                  class="mx-2"
                  @click="scannedPDF.splice(index, 1)"
                  fab
                  mdi-icon
                  x-small
                  light
                >
                  <v-icon x-large color="red">mdi-delete-circle</v-icon>
                </v-btn>

                <validation-provider
                  v-slot="{ errors }"
                  :name="index + 1 + '. Documento'"
                  rules="required"
                >
                  <v-text-field
                    prepend-icon="mdi-file"
                    v-model.trim="pdf.fileName"
                    :error-messages="errors"
                    label="Nombre de archivo"
                    required
                  >
                  </v-text-field>
                </validation-provider>
              </v-col>
            </v-row>
            <v-row class="mt-8">
              <v-col class="text-center">
                <v-btn
                  color="error"
                  plain
                  class="mb-4"
                  router
                  :to="{
                    path: '/recepcion/',
                    name: 'Recepcion',
                  }"
                  ><v-icon left>mdi-chevron-left</v-icon>Volver
                </v-btn>
              </v-col>

              <v-col>
                <v-row
                  class="py-5"
                  align="center"
                  justify="center"
                  v-if="$utilFront.withPermission($prm.ADD_ADDENDUM)"
                >
                  <v-btn
                    class="primary"
                    type="button"
                    @click="saveFiles()"
                    :disabled="
                      sending || invalid || $utilFront.isEmptyList(files)
                    "
                    >{{ sending ? "Guardando archivo..." : "Guardar"
                    }}<v-icon right>mdi-cloud-upload</v-icon></v-btn
                  >
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
        </validation-observer>
      </v-card>
    </div>
  </div>
</template>
<script>
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar.vue";
import { extend, ValidationObserver, ValidationProvider } from "vee-validate";
import Loader from "@/components/Loader.vue";
import PatientInformation from "@/app/components/common/patient/PatientInformation.vue";

import { PatientFileRequest } from "@/core/request";
export default {
  components: {
    Sidebar,
    Loader,
    Encabezado,
    extend,
    ValidationObserver,
    ValidationProvider,
    PatientInformation,
  },
  name: "Addendum",
  data: () => ({
    loader: false,
    scannedPDF: [],
    scannedImages: [],
    encabezado: { icono: "mdi-paperclip", texto: "Archivos adjuntos" },
    files: [],
    sending: false,
    mapping: {},
    idPatient: null,
    addendums: [],
    model: {},
  }),
  created() {
    this.specialCharacter();
    if (this.$route.params.id) {
      this.idPatient = this.$route.params.id;
      this.model = { idPatient: this.idPatient };
    } else {
      this.$router.go(-1);
    }
    this.getAddendums();
  },
  methods: {
    deleteFile(fileName) {
      let i = this.files.findIndex((index) => index.name === fileName);
      if (i > -1) {
        this.files.splice(i, 1);
      }
    },
    catchError(e) {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno.", "ERROR");
    },
    specialCharacter() {
      let from = "ÃÀÁÄÂÈÉËÊÌÍÏÎÒÓÖÔÙÚÜÛãàáäâèéëêìíïîòóöôùúüûÑñÇç",
        to = "AAAAAEEEEIIIIOOOOUUUUaaaaaeeeeiiiioooouuuunncc";

      for (let i = 0, j = from.length; i < j; i++) {
        this.mapping[from.charAt(i)] = to.charAt(i);
      }
    },

    saveFiles() {
      this.loader = true;
      this.sending = true;
      // let registerFiles = true;
      // if(this.addendums.length != 0){
      //   this.addendums.forEach((a) => {
      //     this.files.forEach((f) => {
      //       if(a.fileName == f.name){
      //         registerFiles = false;
      //         this.$utilFront.notifications(
      //             "Archivo con nombre: "+ a.fileName +" ya se encuentra registrado",
      //             "WARNING"
      //           );

      //       }
      //     })
      //   })
      // }
      // if(registerFiles){
      let existEqualsName = false;
      if (this.files.length != 0) {
        this.files.forEach((a) => {
          let count = 0;
          this.files.forEach((f) => {
            if (a.name == f.name) {
              count++;
              if (count > 1) {
                existEqualsName = true;
                this.$utilFront.notifications(
                  "Archivo: " + a.name + " se encuentra repetido",
                  "WARNING"
                );
              }
            }
          });
        });
      }
      if (!existEqualsName) {
        let id = this.$route.params.id;
        let formData = new FormData();
        let names = new Array();
        if (this.files !== undefined) {
          this.files.forEach((file) => {
            let c = "";

            for (var i = 0, j = file.name.length; i < j; i++) {
              var l = file.name.charAt(i);
              c = c + (l in this.mapping ? this.mapping[l] : l);
            }
            let te = c.replace(/[^a-zA-Z0-9-_+{}()&$!#%. ]/g, "");
            formData.append("files", file);
            //names.push(te);
            formData.append("names", te);
          });
        }

        if (
          this.scannedPDF != null &&
          this.scannedPDF != undefined &&
          this.scannedPDF.length > 0
        ) {
          for (let i = 0; i < this.scannedPDF.length; i++) {
            let fileName =
              this.scannedPDF[i].fileName + "." + this.scannedPDF[i].format;
            const filePDF = this.$utilFront.stringBase64ToFile(
              this.scannedPDF[i].file64,
              fileName
            );
            formData.append("files", filePDF);
            formData.append("names", fileName);
          }
        }

        if (
          this.scannedImages != null &&
          this.scannedImages != undefined &&
          this.scannedImages.length > 0
        ) {
          for (let i = 0; i < this.scannedImages.length; i++) {
            let fileName =
              this.scannedImages[i].fileName +
              "." +
              this.scannedImages[i].format;
            const filePDF = this.$utilFront.stringBase64ToFile(
              this.scannedImages[i].file64,
              fileName
            );
            formData.append("files", filePDF);
            formData.append("names", fileName);
          }
        }

        formData.append("idPatient", id);

        var res = Array.from(formData.entries(), ([key, prop]) => ({
          [key]: {
            ContentLength: typeof prop === "string" ? prop.length : prop.size,
          },
        }));
        let totalSize = 0;
        res.forEach((item) => {
          if (item.files && item.files.ContentLength) {
            totalSize += item.files.ContentLength;
          }
        });

        if (totalSize > this.$cnst.LIMIT_LOAD_FILES) {
          this.$utilFront.notifications(
            "Los archivos exceden el límite permido (10MB)",
            "ERROR"
          );
          this.loader = false;
          this.sending = false;
        } else {
          PatientFileRequest.add(formData)
            .then((res) => {
              let { data, status, code } = res.data;
              if (code == 200 && data == true) {
                this.loader = true;
                this.$utilFront.notifications(
                  "Archivo agregado correctamente",
                  "SUCCESS"
                );
                this.loader = false;
                this.$router.push("/recepcion");
              } else if (code == 401) {
                this.unauthorized();
              } else if (typeof data == "string") {
                this.$utilFront.notifications(data, "ERROR");
              } else {
                this.catchError();
              }
            })
            .catch(this.catchError)
            .finally(() => {
              this.sending = false;
              this.loader = false;
            });
        }
      } else {
        this.loader = false;
        this.sending = false;
      }
    },
    saveFilesScanned() {
      this.sending = true;
      if (this.scannedPDF && this.scannedImages) {
        let filesScanned = Object.assign(this.scannedPDF);
        filesScanned = filesScanned.concat(Object.assign(this.scannedImages));
        let idPatient = this.idPatient;

        PatientFileRequest.addFilesScanned({
          idPatient: idPatient,
          files: filesScanned,
        })
          .then((res) => {
            let { data, message, response } = res.data;
            if (response) {
              this.$utilFront.notifications(
                "Documentos guardados correctamente.",
                "SUCCESS"
              );
            } else {
              this.$utilFront.notifications(
                message || "Error interno del servidor.",
                "ERROR"
              );
            }
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    //Scanner
    scanAsImage() {
      let settings = {
        output_settings: [{ type: "return-base64", format: "jpg" }],
      };
      scanner.scan(this.displayImagesOnPage, settings);
    },
    displayImagesOnPage(successful, mesg, response) {
      if (!successful) {
        // On error
        this.$utilFront.notifications("Error en lectura de archivo.", "ERROR");
        return;
      }

      if (
        successful &&
        mesg != null &&
        mesg.toLowerCase().indexOf("user cancel") >= 0
      ) {
        // User cancelled.
        this.$utilFront.notifications("Cancelado.", "WARNING");
        return;
      }

      var scannedImages = scanner.getScannedImages(response, true, false); // returns an array of ScannedImage
      for (
        var i = 0;
        scannedImages instanceof Array && i < scannedImages.length;
        i++
      ) {
        var scannedImage = scannedImages[i];
        this.scannedImages.push({
          file64: scannedImage.src,
          fileName: "Imagen sin titulo (" + (i + 1) + ")",
          format: "jpg",
        });
      }
    },
    scanAsPDF() {
      let settingsFormat = {
        type: "return-base64-thumbnail",
        format: "jpg",
        thumbnail_height: 200,
        image_text_line: "",
      };
      let settings = {
        output_settings: [
          { type: "return-base64", format: "pdf" },
          settingsFormat,
        ],
      };
      scanner.scan(this.displayImagesOnPagePDF, settings);
    },
    displayImagesOnPagePDF(successful, mesg, response) {
      if (!successful) {
        // On error
        this.$utilFront.notifications("Error en lectura de archivo.", "ERROR");
        return;
      }

      if (
        successful &&
        mesg != null &&
        mesg.toLowerCase().indexOf("user cancel") >= 0
      ) {
        // User cancelled.
        this.$utilFront.notifications("Cancelado.", "WARNING");
        return;
      }

      var scannedImages = scanner.getScannedImages(response, true, false); // returns an array of ScannedImage
      for (
        var i = 0;
        scannedImages instanceof Array && i < scannedImages.length;
        i++
      ) {
        var scannedImage = scannedImages[i];
        this.scannedPDF.push({
          file64: scannedImage.src,
          fileName: "Pdf sin titulo (" + (i + 1) + ")",
          format: "pdf",
        });
      }
    },
    getAddendums() {
      try {
        this.sending = true;
        let data = { idPatient: this.idPatient };

        PatientFileRequest.findAddendumsByPatient(data)
          .then((res) => {
            let { data, status, code } = res.data;
            if (code == 200 && typeof data === "object") {
              this.addendums = data.addendumList;
            } else if (code == 401) {
              this.unauthorized();
            } else if (typeof data == "string") {
              //this.$utilFront.notifications(data, "ERROR");
            }
          })
          .catch(e)
          .finally(() => {
            this.sending = false;
          });
      } catch (e) {
        this.sending = false;
      }
    },
  },
};
</script>
